import { Builder } from '@builder.io/sdk';
import { Calculator } from './Calculator';
import { iconInput } from '../Icon/Icon.registry';

const CalculatorConfig = {
  name: 'Calculator',
  defaultStyles: {
    margin: '0',
  },
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'string',
      required: true,
    },
    {
      name: 'cardTitle',
      type: 'string',
      required: true,
    },
    iconInput({
      name: 'cardIcon',
    }),
    {
      name: 'cardLegalText',
      type: 'string',
      required: true,
    },
    {
      name: 'CTAUrl',
      type: 'string',
      required: true,
    },
    {
      name: 'priceTable',
      type: 'reference',
      model: 'pricing-table-options-van-model',
      required: true,
    },
  ],
};

Builder.registerComponent(Calculator, CalculatorConfig);
